<template>
  <div class="goods_info">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="goods_info_top_mbx width_center_1200">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/points/index' }">{{ lang.points_mall }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ info.name }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div v-loading="loading"  class="goods_content width_center_1200">
      <template v-if="info.id > 0">
      <div v-loading="loading" class="goods_info_top">
          <div class="goods_info_pic">
            <el-image :src="info.homeimg"></el-image>
          </div>
          <div class="goods_info_cont">
            <div class="goods_info_title">{{ info.name }}</div>
            <div class="goods_info_price">
              <div class="points"><span>{{ info.integral }}</span>{{ lang.integral }}</div>
              <div class="stock">{{ lang.stock }}：{{ info.canSaleCount }}{{ lang.unit }}</div>
            </div>
            <div class="goods_info_bottom">
              <div class="goods_info_btn">
                <div class="goods_info_buy" @click="buy()">
                  <span>{{ lang.buy }}</span>
                </div>
              </div>
            </div>
            <div class="goods_info_btn" @click="handleExchange(info.id, info.ptype, 1)">{{ lang.exchange }}</div>
          </div>
          <div class="clear"></div>
        </div>
        <div
          v-if="info.vendlist && info.vendlist.length"
          class="machine_list"
        >
          <div class="title">{{ lang.vend_title }}</div>
          <ul :class="{'show': showMachine }">
            <li
              v-for="(item, index) in info.vendlist"
              :key="index"
              @click="changeMachine(item)"
            >
              <div class="cont">
                <div class="check-box" :class="{ 'cur' : info.id === item.productid }"></div>
                <div class="info">
                  <div class="name">
                    <el-image :src="item.vemimg" />
                    {{ item.vemName }}
                  </div>
                  <div class="address">{{ item.vemaddress }}</div>
                </div>
              </div>
              <div class="right">
                <div class="right-content">
                  <div class="location">
                    <svg-icon iconClass="location" />
                    {{ item.distance }}{{ item.distanceunit }}
                  </div>
                  <!-- <div class="btn">{{ lang.location }}</div> -->
                </div>
                <i class="el-icon-arrow-right" />
              </div>
            </li>
          </ul>
          <div
            v-if="info.vendlist.length > 3"
            class="toggle-box"
            @click="showMachine =! showMachine"
          >
            {{ showMachine ? this.lang.pickup : this.lang.unfold }}
            <i :class="showMachine ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
          </div>
        </div>
        <div class="goods_notes">
          <div class="title">{{ lang.rule }}</div>
          <div class="text" v-html="rules.contents"></div>
        </div>
        <div class="goods_detail">
          <div class="title">{{ lang.detail }}</div>
          <div class="content" v-html="info.details"></div>
        </div>
      </template>
    </div>

    <div class="width_center_1200">
      <merchant-promise></merchant-promise>
    </div>

    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import MerchantPromise from '@/components/MerchantPromise/index'
import { getagreement } from '@/api/home'
import { getintegralproductdetail } from '@/api/product'
import { getbuyexchangeorderpay } from '@/api/order'
export default {
  components: {
    ShopTop,
    ShopFoot,
    MerchantPromise
  },
  data() {
    return {
      info: {},
      rules: {},
      machineData: {
        index: 0,
        vemId: ''
      },
      showMachine: false,
      loading: false
    }
  },
  computed: {
    lang() {
      return this.$t('integral_detail')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  watch: {
    location: {
      handler(val) {
        if (val) {
          this.getGoodsInfo(this.$route.query.id, this.$route.query.ptype)
          this.getRuleInfo()
        }
      },
      immediate: true
    }
  },
  methods: {
    // 获取商品信息
    getGoodsInfo(id, ptype) {
      this.loading = true
      getintegralproductdetail({
        id,
        ptype,
        ...this.location
      }).then(({ data }) => {
        this.loading = false
        this.info = data
      })
    },
    changeMachine(item) {
      this.getGoodsInfo(item.productid, item.productptype)
    },
    handleExchange(id, ptype, buynum) {
      this.$confirm(this.lang.tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text
      }).then(() => {
        getbuyexchangeorderpay({ id, ptype, buynum }).then(res => {
          if (res.code === 1) {
            this.$message.success(res.msg)
            this.$store.dispatch('updateUserInfo')
          }
        })
      })
    },
    async getRuleInfo() {
      getagreement({ keyword: 'pointdockey' }).then(({ data }) => {
        this.rules = data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.goods_info_top_mbx {
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
}
.goods_content {
  padding-bottom: 50px;
  .goods_info_top {
    display: flex;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 12px;
    margin-bottom: 20px;
    padding: 32px;
  }
  .goods_info_pic {
    .el-image {
      width: 265px;
      height: 265px;
    }
  }
  .goods_info_cont {
    flex: 1;
    margin-left: 30px;
    .goods_info_title {
      font-size: 18px;
      color: #4f4f4f;
      margin-bottom: 10px;
    }
    .goods_info_price {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .points {
        span {
          padding-right: 3px;
          font-weight: 700;
          font-size: 16px;
        }
        font-size: 12px;
        color: #ec9221;
      }
      .stock {
        color: #aaa;
        font-size: 12px;
      }
    }
    .goods_info_btn {
      text-align: center;
      width: 136px;
      line-height: 40px;
      margin-right: 15px;
      background: #ffd39b;
      border-radius: 6px;
      font-size: 16px;
      color: #ef8500;
      cursor: pointer;
    }
  }
}

.machine_list {
  padding: 15px;
  background: #ffffff;
  margin-bottom: 15px;
  border-radius: 12px;
  .title {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
  }
  ul {
    max-height: 206px;
    overflow: hidden;
    &.show {
      overflow: inherit;
      height: auto;
      max-height: auto;
    }
    li {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      padding: 14px 0;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      .cont {
        display: flex;
        align-items: center;
        flex: 1;
      }
      .info {
        margin-left: 15px;
      }
      .name {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #000;
        margin-bottom: 4px;
        .el-image {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      }
      .address {
        font-size: 12px;
        color: #4f4f4f;
      }
      .right {
        display: flex;
        align-items: center;
      }
      .right-content {
        margin-right: 15px;
      }
      .location {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #aaaaaa;
        margin-bottom: 4px;
      }
      .btn {
        text-align: right;
        font-size: 12px;
        color: #0061b5;
      }
    }
  }
  .toggle-box {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    font-size: 14px;
    color: #4f4f4f;
    cursor: pointer;
    i {
      margin-left: 4px;
      font-size: 18px;
    }
  }
}
.goods_detail {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  .title {
    height: 40px;
    line-height: 40px;
    background: #ec9221;
    padding: 0 15px;
    font-size: 16px;
    color: #fff;
    margin-bottom: 15px;
  }
  /deep/ .content {
    img {
      display: flex;
      width: 100%;
      margin: 0 auto;
    }
  }
}
.goods_notes {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 15px;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #4f4f4f;
    text-align: center;
    padding-bottom: 10px;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #4f4f4f;
    padding-bottom: 16px;
  }
}
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  margin-right: 5px;
  &.cur {
    background: #ec9221;
  }
}
.machine_list {
  padding: 15px;
  background: #ffffff;
  margin-bottom: 15px;
  border-radius: 12px;
  .title {
    margin-bottom: 10px;
    font-size: 14px;
    color: #000;
  }
  ul {
    max-height: 206px;
    overflow: hidden;
    &.show {
      overflow: inherit;
      height: auto;
      max-height: auto;
    }
    li {
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eee;
      padding: 14px 0;
      cursor: pointer;
      &:last-child {
        border-bottom: 0;
      }
      .cont {
        display: flex;
        align-items: center;
      }
      .info {
        margin-left: 15px;
      }
      .name {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #000;
        margin-bottom: 4px;
        .el-image {
          width: 16px;
          height: 16px;
          margin-right: 8px;
        }
      }
      .address {
        font-size: 12px;
        color: #4f4f4f;
      }
      .right {
        display: flex;
        align-items: center;
      }
      .right-content {
        margin-right: 15px;
      }
      .location {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #aaaaaa;
        margin-bottom: 4px;
      }
      .btn {
        text-align: right;
        font-size: 12px;
        color: #0061b5;
      }
    }
  }
  .toggle-box {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 15px 0;
    font-size: 14px;
    color: #4f4f4f;
    cursor: pointer;
    i {
      margin-left: 4px;
      font-size: 18px;
    }
  }
}

</style>